<div>
  <a [routerLink]="postLink" class="card clickable">
    <div class="card-img">
      <img [src]="getImageUrl(post)" [alt]="'Cântece creștine pentru copii - ' + post.title.rendered"/>
    </div>
    <div class="card-block">
      <div class="card-title" [innerHTML]="post.title.rendered"></div>
      <div class="card-tags">
        <span class="tag mr-1 py-1 px-2" *ngFor="let tag of post.readableTagNames">{{tag}}</span>
        <div class="tag-gradient text-right"><fa-icon icon="angle-right"></fa-icon></div>
      </div>
      <div class="card-text">
        <div class="mt-3">Click pentru versuri, partituri și alte detalii</div>
      </div>
    </div>
  </a>
</div>
